import { createUseUpdateGap, UpdateGapBaseParams } from './useUpdateGap';

export interface UpdateFocGapParams extends UpdateGapBaseParams {
    submission_answer?: null | Pick<SubmissionAnswerType, 'metadata'>;
}

export const useUpdateFocGap = createUseUpdateGap<UpdateFocGapParams, GapType>({
    urlPrefix: '/api/foc-gaps/',
    gapProp: 'foc_gaps',
});
